import React from 'react'
import PropTypes from 'prop-types'

const LandingInfoWithPhoto = ({ block, photoOnLeft }) => {
  const { title, description, imgURL, className } = block
  const photoLocation = photoOnLeft ? 'left' : 'right'

  return (
    <div className={`row align-items-center px-0 px-md-5 ${className}`}>
      <div className='col-12 col-xxl-10 offset-0 offset-xxl-1 px-0 py-5 p-lg-5 d-flex flex-column flex-lg-row align-items-start align-items-lg-center'>

        {photoLocation === 'left' &&
          <div className='col-12 col-lg-6 px-5 ps-md-0 pe-md-4'>
            <img src={imgURL} style={{ width: '100%' }} data-cy='landing-info-photo-left' alt='info photo' />
          </div>
        }

        <div className='col-12 col-lg-6 px-5 px-md-0'>
          <div className={`${photoLocation === 'left' ? 'pt-5 ps-md-3 pe-md-5' : 'pb-5 pe-md-5'} py-lg-0`}>
            <div className='text-primary'>
              <p className='h5'>{title}</p>
            </div>
            <div dangerouslySetInnerHTML={{ __html: description }}></div>
          </div>
        </div>

        {photoLocation === 'right' &&
          <div className='col-12 col-lg-6 px-5 ps-md-0 pe-md-4'>
            <img src={imgURL} style={{ width: '100%' }} data-cy='landing-info-photo-right' alt='info photo' />
          </div>
        }

      </div>
    </div>
  )
}

LandingInfoWithPhoto.propTypes = {
  block: PropTypes.object,
  photoOnLeft: PropTypes.bool
}

export default LandingInfoWithPhoto
